import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Search, Phone } from 'lucide-react';

// Comprehensive list of 64 countries
export const COUNTRIES = [
  // South Asia
  { code: 'IN', name: 'India', dial: '+91', flag: '🇮🇳', placeholder: '98765 43210' },
  { code: 'PK', name: 'Pakistan', dial: '+92', flag: '🇵🇰', placeholder: '300 1234567' },
  { code: 'BD', name: 'Bangladesh', dial: '+880', flag: '🇧🇩', placeholder: '1712 345678' },
  { code: 'LK', name: 'Sri Lanka', dial: '+94', flag: '🇱🇰', placeholder: '71 234 5678' },
  { code: 'NP', name: 'Nepal', dial: '+977', flag: '🇳🇵', placeholder: '984 1234567' },
  // Middle East
  { code: 'AE', name: 'UAE', dial: '+971', flag: '🇦🇪', placeholder: '50 123 4567' },
  { code: 'SA', name: 'Saudi Arabia', dial: '+966', flag: '🇸🇦', placeholder: '50 123 4567' },
  { code: 'QA', name: 'Qatar', dial: '+974', flag: '🇶🇦', placeholder: '3312 3456' },
  { code: 'KW', name: 'Kuwait', dial: '+965', flag: '🇰🇼', placeholder: '5123 4567' },
  { code: 'BH', name: 'Bahrain', dial: '+973', flag: '🇧🇭', placeholder: '3612 3456' },
  { code: 'OM', name: 'Oman', dial: '+968', flag: '🇴🇲', placeholder: '9212 3456' },
  { code: 'JO', name: 'Jordan', dial: '+962', flag: '🇯🇴', placeholder: '7 9012 3456' },
  { code: 'LB', name: 'Lebanon', dial: '+961', flag: '🇱🇧', placeholder: '71 123 456' },
  { code: 'IL', name: 'Israel', dial: '+972', flag: '🇮🇱', placeholder: '50 123 4567' },
  // Southeast Asia
  { code: 'SG', name: 'Singapore', dial: '+65', flag: '🇸🇬', placeholder: '8123 4567' },
  { code: 'MY', name: 'Malaysia', dial: '+60', flag: '🇲🇾', placeholder: '12 345 6789' },
  { code: 'ID', name: 'Indonesia', dial: '+62', flag: '🇮🇩', placeholder: '812 3456 7890' },
  { code: 'TH', name: 'Thailand', dial: '+66', flag: '🇹🇭', placeholder: '81 234 5678' },
  { code: 'VN', name: 'Vietnam', dial: '+84', flag: '🇻🇳', placeholder: '91 234 5678' },
  { code: 'PH', name: 'Philippines', dial: '+63', flag: '🇵🇭', placeholder: '917 123 4567' },
  // East Asia
  { code: 'CN', name: 'China', dial: '+86', flag: '🇨🇳', placeholder: '131 2345 6789' },
  { code: 'JP', name: 'Japan', dial: '+81', flag: '🇯🇵', placeholder: '90 1234 5678' },
  { code: 'KR', name: 'South Korea', dial: '+82', flag: '🇰🇷', placeholder: '10 1234 5678' },
  { code: 'HK', name: 'Hong Kong', dial: '+852', flag: '🇭🇰', placeholder: '5123 4567' },
  { code: 'TW', name: 'Taiwan', dial: '+886', flag: '🇹🇼', placeholder: '912 345 678' },
  // North America
  { code: 'US', name: 'United States', dial: '+1', flag: '🇺🇸', placeholder: '555 123 4567' },
  { code: 'CA', name: 'Canada', dial: '+1', flag: '🇨🇦', placeholder: '416 123 4567' },
  { code: 'MX', name: 'Mexico', dial: '+52', flag: '🇲🇽', placeholder: '55 1234 5678' },
  // Europe
  { code: 'GB', name: 'United Kingdom', dial: '+44', flag: '🇬🇧', placeholder: '7911 123456' },
  { code: 'DE', name: 'Germany', dial: '+49', flag: '🇩🇪', placeholder: '151 1234 5678' },
  { code: 'FR', name: 'France', dial: '+33', flag: '🇫🇷', placeholder: '6 12 34 56 78' },
  { code: 'IT', name: 'Italy', dial: '+39', flag: '🇮🇹', placeholder: '312 345 6789' },
  { code: 'ES', name: 'Spain', dial: '+34', flag: '🇪🇸', placeholder: '612 34 56 78' },
  { code: 'NL', name: 'Netherlands', dial: '+31', flag: '🇳🇱', placeholder: '6 12345678' },
  { code: 'BE', name: 'Belgium', dial: '+32', flag: '🇧🇪', placeholder: '470 12 34 56' },
  { code: 'CH', name: 'Switzerland', dial: '+41', flag: '🇨🇭', placeholder: '78 123 45 67' },
  { code: 'AT', name: 'Austria', dial: '+43', flag: '🇦🇹', placeholder: '664 123 4567' },
  { code: 'SE', name: 'Sweden', dial: '+46', flag: '🇸🇪', placeholder: '70 123 45 67' },
  { code: 'NO', name: 'Norway', dial: '+47', flag: '🇳🇴', placeholder: '412 34 567' },
  { code: 'DK', name: 'Denmark', dial: '+45', flag: '🇩🇰', placeholder: '20 12 34 56' },
  { code: 'FI', name: 'Finland', dial: '+358', flag: '🇫🇮', placeholder: '41 234 5678' },
  { code: 'PL', name: 'Poland', dial: '+48', flag: '🇵🇱', placeholder: '512 345 678' },
  { code: 'CZ', name: 'Czech Republic', dial: '+420', flag: '🇨🇿', placeholder: '601 234 567' },
  { code: 'PT', name: 'Portugal', dial: '+351', flag: '🇵🇹', placeholder: '912 345 678' },
  { code: 'IE', name: 'Ireland', dial: '+353', flag: '🇮🇪', placeholder: '85 123 4567' },
  { code: 'GR', name: 'Greece', dial: '+30', flag: '🇬🇷', placeholder: '691 234 5678' },
  { code: 'RO', name: 'Romania', dial: '+40', flag: '🇷🇴', placeholder: '712 345 678' },
  { code: 'HU', name: 'Hungary', dial: '+36', flag: '🇭🇺', placeholder: '20 123 4567' },
  { code: 'RU', name: 'Russia', dial: '+7', flag: '🇷🇺', placeholder: '912 345 6789' },
  { code: 'UA', name: 'Ukraine', dial: '+380', flag: '🇺🇦', placeholder: '50 123 4567' },
  { code: 'TR', name: 'Turkey', dial: '+90', flag: '🇹🇷', placeholder: '532 123 4567' },
  // Oceania
  { code: 'AU', name: 'Australia', dial: '+61', flag: '🇦🇺', placeholder: '412 345 678' },
  { code: 'NZ', name: 'New Zealand', dial: '+64', flag: '🇳🇿', placeholder: '21 123 4567' },
  // Africa
  { code: 'ZA', name: 'South Africa', dial: '+27', flag: '🇿🇦', placeholder: '71 123 4567' },
  { code: 'NG', name: 'Nigeria', dial: '+234', flag: '🇳🇬', placeholder: '802 123 4567' },
  { code: 'KE', name: 'Kenya', dial: '+254', flag: '🇰🇪', placeholder: '712 345678' },
  { code: 'EG', name: 'Egypt', dial: '+20', flag: '🇪🇬', placeholder: '100 123 4567' },
  { code: 'MA', name: 'Morocco', dial: '+212', flag: '🇲🇦', placeholder: '612 345678' },
  // South America
  { code: 'BR', name: 'Brazil', dial: '+55', flag: '🇧🇷', placeholder: '11 91234 5678' },
  { code: 'AR', name: 'Argentina', dial: '+54', flag: '🇦🇷', placeholder: '11 1234 5678' },
  { code: 'CO', name: 'Colombia', dial: '+57', flag: '🇨🇴', placeholder: '310 123 4567' },
  { code: 'CL', name: 'Chile', dial: '+56', flag: '🇨🇱', placeholder: '9 1234 5678' },
  { code: 'PE', name: 'Peru', dial: '+51', flag: '🇵🇪', placeholder: '912 345 678' },
];

export const CountryPhoneInput = ({ 
  countryCode, 
  setCountryCode, 
  phone, 
  setPhone, 
  label = "WhatsApp Number",
  required = true,
  testIdPrefix = "country-phone"
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);

  const selectedCountry = COUNTRIES.find(c => c.code === countryCode) || COUNTRIES[0];

  // Filter countries based on search
  const filteredCountries = COUNTRIES.filter(country => 
    country.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    country.dial.includes(searchQuery) ||
    country.code.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
        setSearchQuery('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Focus search input when dropdown opens
  useEffect(() => {
    if (showDropdown && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [showDropdown]);

  const handleCountrySelect = (country) => {
    setCountryCode(country.code);
    setShowDropdown(false);
    setSearchQuery('');
  };

  return (
    <div>
      <label className="block text-sm font-medium text-white/70 mb-2">
        {label} {required && <span className="text-red-400">*</span>}
      </label>
      <div className="flex gap-2">
        {/* Country Selector with Search */}
        <div className="relative" ref={dropdownRef}>
          <button
            type="button"
            onClick={() => setShowDropdown(!showDropdown)}
            className="flex items-center gap-2 px-3 py-3 bg-white/5 border border-white/10 rounded-lg text-white text-sm hover:bg-white/10 transition-colors min-w-[100px]"
            data-testid={`${testIdPrefix}-country-btn`}
          >
            <span className="text-lg">{selectedCountry.flag}</span>
            <span className="text-white/80">{selectedCountry.dial}</span>
            <ChevronDown size={14} className={`text-white/50 transition-transform ${showDropdown ? 'rotate-180' : ''}`} />
          </button>
          
          {showDropdown && (
            <div className="absolute z-50 mt-1 w-72 max-h-80 bg-[#1a1a2e] border border-white/20 rounded-xl shadow-2xl overflow-hidden">
              {/* Search Input */}
              <div className="p-2 border-b border-white/10">
                <div className="relative">
                  <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
                  <input
                    ref={searchInputRef}
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search country or code..."
                    className="w-full pl-9 pr-3 py-2 bg-white/5 border border-white/10 rounded-lg text-white text-sm placeholder:text-white/30 focus:outline-none focus:border-[#F59E0B]/50"
                    data-testid={`${testIdPrefix}-search`}
                  />
                </div>
              </div>
              
              {/* Country List */}
              <div className="max-h-60 overflow-y-auto">
                {filteredCountries.length > 0 ? (
                  filteredCountries.map((country) => (
                    <button
                      key={country.code}
                      type="button"
                      onClick={() => handleCountrySelect(country)}
                      className={`w-full flex items-center gap-3 px-3 py-2.5 hover:bg-white/10 transition-colors text-left ${
                        country.code === countryCode ? 'bg-[#F59E0B]/20' : ''
                      }`}
                      data-testid={`${testIdPrefix}-option-${country.code}`}
                    >
                      <span className="text-xl">{country.flag}</span>
                      <div className="flex-1 min-w-0">
                        <span className="text-white text-sm truncate block">{country.name}</span>
                      </div>
                      <span className="text-white/50 text-sm font-mono">{country.dial}</span>
                    </button>
                  ))
                ) : (
                  <div className="px-3 py-4 text-center text-white/40 text-sm">
                    No countries found
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Phone Input */}
        <div className="flex-1 relative">
          <Phone size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value.replace(/[^\d\s]/g, ''))}
            placeholder={selectedCountry.placeholder}
            className="w-full pl-10 pr-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white text-sm placeholder:text-white/30 focus:outline-none focus:border-[#F59E0B]/50"
            required={required}
            data-testid={`${testIdPrefix}-input`}
          />
        </div>
      </div>
    </div>
  );
};

export default CountryPhoneInput;
